module.exports = __webpack_public_path__ + "img/854d35aa24727e2c251608ea0861e0c5.png";